import { render, staticRenderFns } from "./AMZInvoiceCreator.vue?vue&type=template&id=234aed1c"
import script from "./AMZInvoiceCreator.vue?vue&type=script&lang=js"
export * from "./AMZInvoiceCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports